// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1pH8J","productName":"Table_productName__2fSEC"};